<h1 mat-dialog-title>Accept Quote</h1>
<div mat-dialog-content>
  <p>Are you sure you want to move this quote line to the appointment?</p>

</div>
<div mat-dialog-actions class="self-center">
  <button mat-button mat-dialog-close="no">No</button>
  <button mat-button mat-dialog-close="yes" cdkFocusInitial>Yes</button>
</div>